import React from 'react';
import { useView } from '../../contexts/ViewContext';
import Publications from './Publications';
import PublicationEditor from './PublicationEditor';
import PublicationDetailPage from './PublicationDetailPage';

const PublicationsWrapper: React.FC = () => {
  const { view, setView } = useView();

  if (view.subPage === 'edit' || view.subPage === 'new') {
    return <PublicationEditor publicationId={view.id ? String(view.id) : undefined} setView={setView} />;
  }

  if (view.subPage === 'detail' && view.id) {
    return <PublicationDetailPage publicationId={String(view.id)} setView={setView} />;
  }

  return <Publications setView={setView} />;
};

export default PublicationsWrapper;
